import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { auth } from '../firebase'; // Make sure this is the correct path to your Firebase setup

function ManageCourses() {
  const [courses, setCourses] = useState([]);
  const [form, setForm] = useState({ name: '', description: '' });
  const [editingId, setEditingId] = useState(null);

  const fetchCourses = async () => {
    try {
      const user = auth.currentUser;
      const token = user && await user.getIdToken();

      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/courses`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setCourses(res.data);
    } catch (err) {
      console.error('Failed to load courses', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const user = auth.currentUser;
      const token = user && await user.getIdToken();

      if (editingId) {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/courses/${editingId}`, form, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/courses`, form, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }

      setForm({ name: '', description: '' });
      setEditingId(null);
      fetchCourses();
    } catch (err) {
      console.error('Submit failed', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this course?')) return;

    try {
      const user = auth.currentUser;
      const token = user && await user.getIdToken();

      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/courses/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      fetchCourses();
    } catch (err) {
      console.error('Delete failed', err);
    }
  };

  const startEditing = (course) => {
    setForm({ name: course.name, description: course.description });
    setEditingId(course.id);
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  return (
    <div>
      <h2>Manage Courses</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Course Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
        />
        <textarea
          placeholder="Course Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          required
        />
        <button type="submit">{editingId ? 'Update' : 'Add'} Course</button>
      </form>

      <ul>
        {courses.map((c) => (
          <li key={c.id}>
            <strong>{c.name}</strong> – {c.description}
            <button onClick={() => startEditing(c)}>Edit</button>
            <button onClick={() => handleDelete(c.id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ManageCourses;
